import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/ToggleButton/SelectAllButton.js";
const variants = import.meta.webpackContext("/components/ToggleButton", { recursive: true, regExp: /\.\/__variants__\/plp\-filtering\-experience\/v2\/SelectAllButton\.js/ });
export default pointCut({ joinPoint, variants });